module.exports = __webpack_public_path__ + "img/home1.cb8f9921.gif";